import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const selectOrderTableStore = (state) => state.orderTable;

const makeSelectOrderTable = () => createSelector(
  selectOrderTableStore,
  ({ reportTableOrder }) => reportTableOrder,
);

const makeSelectIDB = () => createSelector(
  selectOrderTableStore,
  ({ idb }) => idb,
);

const makeSelectIDBProps = () => createSelector(
  selectOrderTableStore,
  ({ idbProps }) => idbProps,
);

export {
  makeSelectIDB,
  makeSelectIDBProps,
  makeSelectOrderTable,
};
